import React from 'react';

const DrawingSettings = ({ settings, onSettingsChange, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="drawing-settings-panel">
      <h4>Drawing Settings</h4>
      
      <div className="setting-row">
        <label>Stroke Width:</label>
        <input
          type="range"
          min="1"
          max="20"
          value={settings.strokeWidth}
          onChange={(e) => onSettingsChange('strokeWidth', parseInt(e.target.value))}
        />
        <span>{settings.strokeWidth}px</span>
      </div>
      
      <div className="setting-row">
        <label>Color:</label>
        <input
          type="color"
          value={settings.strokeColor}
          onChange={(e) => onSettingsChange('strokeColor', e.target.value)}
        />
      </div>
      
      <div className="setting-row">
        <label>Smoothness:</label>
        <input
          type="range"
          min="0"
          max="1"
          step="0.1"
          value={settings.smoothness}
          onChange={(e) => onSettingsChange('smoothness', parseFloat(e.target.value))}
        />
        <span>{Math.round(settings.smoothness * 100)}%</span>
      </div>
      
      <div className="setting-row">
        <label>Opacity:</label>
        <input
          type="range"
          min="0.1"
          max="1"
          step="0.1"
          value={settings.opacity}
          onChange={(e) => onSettingsChange('opacity', parseFloat(e.target.value))}
        />
        <span>{Math.round(settings.opacity * 100)}%</span>
      </div>
    </div>
  );
};

export default DrawingSettings;
